export const initialState = {
    basket: [],
};

export const getBasketTotal = (basket)=>
basket?.reduce((amount,item)=>item.price+amount,0);

const reducer = (state, action) => {
    console.log(action);
    switch (action.type) {
        case 'ADD_TO_BASKET':
            // Logic for adding item to basket
            return {
                ...state,
                basket: [...state.basket, action.item]
            }
            break;
        case 'REMOVE_FROM_BASKET':
            // Logic for removing item to basket

            let newBasket = [...state.basket];
            const index = state.basket.findIndex((basketItem) => basketItem.id === action.id)
            if (index >= 0) {
                newBasket.splice(index, 1);

            } else {
                console.warn(
                    'Cant remove product (id: ${action.id})as its not there'
                );
            }

            return {
                ...state,
                basket: newBasket,
            };
        default:
            return state;
    }
}

export default reducer;